import { gql } from 'apollo-angular';
import { Tenant } from '../../entities/tenant/tenant';

export const TENANT_QUERY = gql`
query getInvoices(
  $tenantId: String
)
{
  tenant: getTenantByTenantId(
    tenantId: $tenantId
  )
  {
    id
    hasOpenLicenceRequests
    invoiceEmail
    invoiceAddress {
      id
      name
      addressLine0
      addressLine1
      postalCode
      city
      country
      vatNumber
      vatType
    }
  }
}
`;

export interface TenantQueryResponse {
  loading: boolean;
  tenant: Tenant;
}
